// client/src/components/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  image = "https://ferejhotel.com/images/hotel-front.jpg",
  url = "https://ferejhotel.com/",
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Ferej Hotel Sol" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Hotel Schema Markup (only included on homepage) */}
      {url === "https://ferejhotel.com/" && (
        <script type="application/ld+json">{`
        {
          "@context": "https://schema.org",
          "@type": "Hotel",
          "name": "Ferej Hotel Sol",
          "image": "${image}",
          "@id": "https://ferejhotel.com",
          "url": "${url}",
          "telephone": "+251900000000",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Ajip Mobile, Harar",
            "addressLocality": "Harar",
            "addressCountry": "ET"
          },
          "description": "${description}",
          "priceRange": "$$",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 9.3148,
            "longitude": 42.1256
          }
        }
        `}</script>
      )}
    </Helmet>
  );
};

export default SEO;
